import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-load-window',
  templateUrl: './load-window.component.html',
  styleUrls: ['./load-window.component.css']
})
export class LoadWindowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
